import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Input from '../../components/ui/Input';
import Button from '../../components/ui/Button';
import { useAuth } from '../../context/AuthContext';
const Login: React.FC = () => {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await login(phone, password);
      navigate('/');
    } catch (err) {
      setError('Invalid phone number or password');
    }
  };
  return <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4" data-id="element-224">
      <div className="max-w-md w-full bg-white rounded-lg border border-gray-200 shadow-md p-8" data-id="element-225">
        <div className="text-center mb-8" data-id="element-226">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bzuBe8K7tpwiJaFhSgXiCs/image.png" alt="Just Cheetah" className="mx-auto h-12 mb-4" data-id="element-227" />
          <h2 className="text-2xl font-semibold" data-id="element-228">Log in</h2>
          <p className="text-gray-600 mt-1" data-id="element-229">
            Continue your food journey with Just Cheetah
          </p>
        </div>
        {error && <div className="mb-4 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded" data-id="element-230">
            {error}
          </div>}
        <form onSubmit={handleSubmit} data-id="element-231">
          <Input label="Mobile No." type="tel" placeholder="Enter your mobile number" value={phone} onChange={e => setPhone(e.target.value)} required data-id="element-232" />
          <Input label="Password" type="password" placeholder="Enter your password" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-233" />
          <Button type="submit" fullWidth size="lg" data-id="element-234">
            Log In
          </Button>
        </form>
        <div className="text-center mt-6" data-id="element-235">
          <Link to="/forgot-password" className="text-[#E84118] hover:underline" data-id="element-236">
            Forgot Password
          </Link>
        </div>
        <div className="text-center mt-8 border-t border-gray-200 pt-6" data-id="element-237">
          <p className="text-gray-600" data-id="element-238">
            Don't have an account?{' '}
            <Link to="/signup" className="text-[#E84118] font-medium hover:underline" data-id="element-239">
              Sign Up Now
            </Link>
          </p>
        </div>
      </div>
    </div>;
};
export default Login;